import { Component, Input, ChangeDetectorRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { fileValidator } from 'src/app/validators/file-validator';
import { fileSizeValidator } from 'src/app/validators/file-size-validator';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnChanges {
  @Input() myForm: FormGroup;
  @Output() newFile: EventEmitter<any> = new EventEmitter<any>();
  @Input() doc: File;

  constructor(private ref: ChangeDetectorRef) { }

  ngOnChanges() {
    this.ref.detectChanges();
  }

  public updateFile(doc: any): void {
    this.doc = doc;
  }

  public fileChange(event, file?: HTMLInputElement): void {
    let size = 0;
    this.doc =  event.target.files ? event.target.files[0] : null;
    size = this.doc ? this.doc.size : 0;
    this.myForm.controls['doc'].setValidators( [Validators.required, fileValidator(), fileSizeValidator(size)] );
    this.newFile.emit(this.doc);
    this.myForm.get('doc').setValue(this.doc, {emitModelToViewChange: false});
    this.myForm.updateValueAndValidity();
  }
}
